import components from "./components/index";
import containers from "./containers/index";
import helpers from "./helpers/index";

const ui = {
  components,
  containers,
  helpers
};

export default ui;
